import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useShop, API } from "../context/ShopContext";
import { useLocale } from "../context/LocaleContext";

// Bridge-style page title bar (light gray, centered title with separator)
export const PageTitle = ({ title, subtitle }) => (
  <div className="idm-page-title" data-testid="page-title">
    <h1>{title}</h1>
    <span className="idm-separator" />
    {subtitle && <p className="idm-page-subtitle">{subtitle}</p>}
  </div>
);

// Slim footer - compact rows with logo, copy and legal links
export const Footer = () => {
  const { t, lang } = useShop();
  const { lp } = useLocale();
  const [legalPages, setLegalPages] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/pages`)
      .then((res) => setLegalPages(res.data))
      .catch(() => {});
  }, []);

  return (
    <footer className="idm-footer" data-testid="footer">
      <div className="idm-footer-row">
        <Link to={lp("/")}>
          <img src="/images/logo-icon-white.png" alt="IdeaMedia" className="idm-footer-logo" />
        </Link>
        <p className="idm-footer-copy">
          © {new Date().getFullYear()} IdeaMedia — {t("footerRights")} | Via Fornaci 215/B, 35131 Padova | P.IVA 05117210285
        </p>
      </div>
      {legalPages.length > 0 && (
        <nav className="idm-footer-links" data-testid="footer-legal-links">
          {legalPages.map((p) => (
            <Link key={p.slug} to={lp(`/pagine/${p.slug}`, p.slug_en)} data-testid={`footer-link-${p.slug}`}>
              {p.title[lang]}
            </Link>
          ))}
        </nav>
      )}
    </footer>
  );
};
